import React, { useState, useEffect, Fragment, lazy } from "react";
import { EditableArea } from "@magnolia/react-editor";
import { connect } from "react-redux";
import { multilanguage } from "redux-multilanguage";
import { useDetailPageQuery } from "../../../utils/location";
import { wfetch } from "../../../utils/fetch";
import { environment } from "../../../environment";
import { DYNAMIC_PAGE_QUERY_KEYS } from "../../../utils/constants/pagePaths";
import Breadcrumb from "../../../components/magnolia/breadcrumb/Breadcrumb";
import HtmlHeader from "../../../components/magnolia/htmlHeader/HtmlHeader";
import Product from "../../../components/magnolia/productDetail/ProductDetail";
import { getProduct } from "../../../services/products.service";

const ProductDetail = ({ currentLanguageCode, main, title, meta, geo }) => {
    const [product, setProduct] = useState({});
    // URL carries either:
    //   /product/<name>                       (legacy / JCR — name-based lookup)
    //   /product/<id>?source=salesforce-sfcc  (multi-source — external endpoint)
    const { id: productId, source } = useDetailPageQuery(DYNAMIC_PAGE_QUERY_KEYS["PRODUCT_DETAIL"]);

    useEffect(() => {
        async function fetchData() {
            const productNode = await getProduct({ lang: currentLanguageCode, source, productId });

            if (productNode) setProduct(productNode);
        }

        if (!productId) return;

        fetchData();
    }, [currentLanguageCode, productId, source]);

    return (
        <Fragment>
            <HtmlHeader title={product ? product.displayName || product["@name"] : title} meta={meta} geo={geo} />
            <Breadcrumb />
            <Product product={product} source={source} />
            {main && <EditableArea content={main} />}
        </Fragment>
    );
};

export default connect()(multilanguage(ProductDetail));
